import { Injectable } from '@angular/core';
import { IMemberformViewState, IMeetingsview } from '@app/models/memberform/memberformviewstate';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class MemberformService {
  medlemsid;
  medid = new BehaviorSubject(null);
  memberformstate: IMemberformViewState = null;
  accordionstatus = new BehaviorSubject(null);
  mentorsearch = new BehaviorSubject(null);
  defaultmeeting: IMeetingsview = { fromdate: '', todate: '', onlyactualinstitution: false };

  constructor() {

    /* Hämta inställningar från localStorage om det finns - annars sätts meetingsview = defaultmeeting. */
    this.medid.subscribe(x => {
      this.medlemsid = x;
      if (this.memberformstate) {
        if (this.memberformstate.id !== this.medlemsid) {
          this.resetMemberformState();
        }
        this.memberformstate.id = this.medlemsid;
        this.setMemberformstate();
      }
    });

    // om memberid === id i localStorage så sätts memberformstate = localStorage.memberformstate. Annars körs resetMemberformState.
    localStorage.memberformstate ? this.memberformstate = JSON.parse(localStorage.memberformstate) : this.resetMemberformState();

    this.accordionstatus.next(this.memberformstate);
  }

  resetMemberformState() {
    this.memberformstate = {
      id: this.medlemsid,
      member: true,
      homeaddress: false,
      workaddress: false,
      otheraddress: false,
      phonenumber: false,
      email: false,
      signs: false,
      meetings: false,
      actualmembership: false,
      actualcommitment: false,
      meetingsview: this.defaultmeeting,
      photo: false
    };
  }

  toggleAllPanels(state) {
    let meetingsview: IMeetingsview;

    // tslint:disable-next-line:max-line-length
    localStorage.memberformstate.meetingsview ? meetingsview = localStorage.memberformstate.meetingsview : meetingsview = this.defaultmeeting;
    this.memberformstate = {
      id: this.medlemsid,
      member: state,
      homeaddress: state,
      workaddress: state,
      otheraddress: state,
      phonenumber: state,
      email: state,
      signs: state,
      meetings: state,
      actualmembership: state,
      actualcommitment: state,
      meetingsview: meetingsview,
      photo: state
    };
    this.setMemberformstate();
  }

  updateAccordions(memberformstate) {
    localStorage.setItem('memberformstate', JSON.stringify(memberformstate));
  }

  updateMeetingsview(meetingsview) {
    const fromdate = meetingsview.FromDate;
    const todate = meetingsview.ToDate;
    const onlyactualinstitution = meetingsview.OnlyIncludeOwnLodgeMeetings;
    const _meetingsview: IMeetingsview = { fromdate: fromdate, todate: todate, onlyactualinstitution: onlyactualinstitution };
    this.memberformstate.meetingsview = _meetingsview;
    this.setMemberformstate();
  }

  setMemberformstate() {
    this.accordionstatus.next(this.memberformstate);
    this.updateAccordions(this.memberformstate);
  }

}
